import { combineReducers } from "redux";
import {navbar} from "./navbar";

// import { faqsPageCollection } from "./faqs";

export const rootReducer = combineReducers({
  // faqsPageCollection,
  navbar
});
